export default __webpack_public_path__ + "static/media/img_product04.8be20cba.png";